import $ from 'cash-dom';
import Cookie from 'js-cookie';
import { request, apiBase } from '@common/request';
import { openLoginModal, isLoggedIn } from '@common/headers/login';
import { ShowAlert } from '@common/utils/alert';

/**
 * "Follow this merchant/category" — the #lkMer button.
 *
 * ENDPOINT IS INTERNATIONAL'S. .in calls `misc/fave/<catID>/<catType>`, a
 * GrabOn.Web .NET route that does not exist on this backend. The gateway takes
 * the same call the coupon like button makes:
 *
 *   POST /favorites  { entityType, entityId }   Authorization: Bearer <token>
 *
 * ENTITY TYPE IS A WORD, NOT A NUMBER. .in passes its numeric CategoryTypeID
 * straight into the URL and keeps a map purely for the toast wording. The
 * gateway wants "merchant" / "category" / "festival" (SavedItemType in the
 * Next.js app), so the numeric page type is translated once, here.
 *
 * ENTITY ID IS THE PAGE'S OWN UUID. `data-pageid` on the body carries it —
 * CategoryPageService sets it to the category row's `id`, which is exactly
 * what /favorites matches on.
 */

/**
 * Numeric page type (src/shared/enums.ts) → what the gateway and the toast
 * each call it. .in's map covers India-only types (Bank/Wallet, Brand, City)
 * that this backend has no page for; those are gone rather than carried as
 * entries that can never fire.
 */
const ENTITY_BY_PAGE_TYPE = {
  1: { entityType: 'merchant', label: 'Merchant', plural: 'Merchants' },
  2: { entityType: 'category', label: 'Category', plural: 'Categories' },
  5: { entityType: 'festival', label: 'Festival', plural: 'Festivals' },
};

export default function merchantFollowInit() {
  const button = $('#lkMer');
  if (!button.length) return;

  button.on('click', async function () {
    if (!isLoggedIn()) {
      openLoginModal();
      return;
    }

    const $t = $(this);
    if ($t.hasClass('animate')) return;

    const body = $('body');
    const entityId = body.attr('data-pageid');
    const pageType = parseInt(body.attr('data-pagetype'), 10);
    const entity = ENTITY_BY_PAGE_TYPE[pageType];

    // A page type with no favourite equivalent must do nothing rather than
    // post a guess — the gateway would store it against the wrong kind.
    if (!entityId || !entity) return;

    const saved = await request.post(
      apiBase() + '/favorites',
      { entityType: entity.entityType, entityId },
      { bearer: Cookie.get('access_token') },
    );

    // THIS REPO'S ShowAlert IS (message, {type}), not .in's five-argument
    // (context, message, image, emotion, fav). Its default icons are inline
    // SVGs precisely because .in's toast images live on India's CDN and are not
    // mirrored — `goGlobal.IMAGE_URL` is not even a key in goGlobal, so every
    // .in-style call in these bundles resolves to "undefinedweb-images/…".
    if (!saved) {
      ShowAlert('Unable to save that right now. Please try again.', { type: 'error' });
      return;
    }

    $t.addClass('animate');
    ShowAlert(`We just saved your ${entity.label.toLowerCase()}.`);
  });
}
